<div class="container">
    <h1 class="page-title"
    [helpCenterButton]="viewPermissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="viewPermissionCode" [position]="'inline'" [lang]="currentLang">
      <span class="icon"><i class="fas fa-stamp"></i></span>{{ 'CompanyStampMaintenance.Header' | translate }}</h1>
    <p-card>
        <p-accordion>
            <p-accordionTab header="{{ 'Common.Form.Header' | translate }}" [selected]="isSearchFormOpen">
                <form [formGroup]="searchForm">
                    <div class="p-fluid formgrid grid">
                        <div class="col-12 md:col-6 lg:col-4 mb-3">
                            <label>{{ 'CompanyStampMaintenance.Search.DONum' | translate }}</label>
                            <input type="text" pInputText formControlName="doNo" [(ngModel)]="searchParams.doNo">
                            <small *ngIf="submitted && f.doNo.errors" class="errors">
                              <div *ngIf="f.doNo.errors.required" class="p-invalid">{{ 'CompanyStampMaintenance.Search.DONum' | translate }} is required</div>
                            </small>
                        </div>
                    </div>
                    <div class="grid">
                        <div class="col">
                            <button pButton pRipple label="{{ 'Common.Button.Search' | translate }}" (click)="searchClickBtn($event)"></button>
                            <button pButton pRipple label="{{ 'Common.Button.Reset' | translate }}" (click)="resetBtnClick($event)" class="p-button-secondary ml-2"></button>

                            <button pButton pRipple label="{{ 'Common.Button.FileUpload' | translate }}" class="p-button-info ml-5" (click)="uploadClickBtn($event)"></button>
                        </div>
                    </div>
                </form>
            </p-accordionTab>
        </p-accordion>
        <div class="mt-2">
            <p-table #CustomerChopSignTable laasDataTableSetting [tableKey]="preferenceKey" [defaultColumns]="columns" [value]="chopSignResults" class="datatable" [loading]="isLoading" styleClass="p-datatable-striped" dataKey="seqNo">
                <ng-template pTemplate="caption">
                    <laas-table-column-toggle
                      [optionsColumn]="columns"
                      [dataTable]="CustomerChopSignTable">
                    </laas-table-column-toggle>
                </ng-template>
                <ng-template pTemplate="colgroup" let-columns>
                    <colgroup>
                        <col *ngFor="let col of columns" [style]="{ width: col.width + 'px' }">
                    </colgroup>
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th [pSortableColumn]="col.field" *ngFor="let col of columns" pResizableColumn pReorderableColumn [attr.field]="col.field">
                          {{ col.header | translate }}
                          <p-sortIcon [field]="col.field"></p-sortIcon>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr>
                        <td *ngFor="let col of columns">
                            <div [ngSwitch]="col.field">
                                <ng-container *ngSwitchCase="'sn'">
                                    <div class="overflow-text">
                                        <img style="width: 100%;" [src]="getImgUrl(rowData.sn) | image | async" />
                                    </div>
                                </ng-container>
                                <ng-container *ngSwitchCase="'effectiveEndDate'">
                                    <div class="overflow-text">
                                        {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                                        <i *ngIf="!rowData.expired" class="fas fa-pencil-alt p=ml-5" (click)="openOverLay($event, rowData)"></i>
                                    </div>
                                </ng-container>
                                <ng-container *ngSwitchDefault>
                                    <ng-container [ngSwitch]="col.dataType">
                                        <ng-container *ngSwitchCase="'date'">
                                            <div class="overflow-text">
                                                {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                                            </div>
                                        </ng-container>
                                        <ng-container *ngSwitchDefault>
                                            <div class="overflow-text">
                                                {{ rowData[col.field] | replaceNullWith:'-'}}
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td [attr.colspan]="columns.length + 1" style="text-align: center;">
                            {{ 'Common.Table.NoData' | translate }}
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </p-card>

    <p-overlayPanel #op [showCloseIcon]="true" [style]="{width: '450px'}" appendTo="body">
        <ng-template pTemplate>
            <div class="p-fluid formgrid grid">
                <div class="field col-12">
                    <label>迄日</label>
                    <p-calendar dateFormat="yy/mm/dd" [minDate]="updateParmas.minDate" [(ngModel)]="updateParmas.effectiveEndDateTimeZone"></p-calendar>
                </div>
            </div>
            <div class="grid">
                <div class="col">
                    <button pButton pRipple label="{{ 'Common.Button.Save' | translate }}" (click)="saveEffectiveEndDate($event)"></button>
                </div>
            </div>
        </ng-template>
    </p-overlayPanel>


    <p-dialog [(visible)]="showUpload" appendTo="body">
        <ng-template pTemplate="header">
            <span style="font-weight: bold;"> {{ 'CompanyStampMaintenance.UploadFile.UploadFile' | translate }} </span>
        </ng-template>
        <ng-template pTemplate="body">
            <div class="formgrid grid">
                <div class="flex align-items-center gap-3 field col-12">
                    <label>{{ 'CompanyStampMaintenance.UploadFile.StartEnd' | translate }} :</label>
                    <p-calendar dateFormat="yy/mm/dd" appendTo="body" [(ngModel)]="uploadParams.effectiveStartDateTimeZone"></p-calendar> 
                    <span>~</span>
                    <p-calendar dateFormat="yy/mm/dd" appendTo="body" [(ngModel)]="uploadParams.effectiveEndDateTimeZone"></p-calendar>

                    <label>{{ 'CompanyStampMaintenance.UploadFile.ForceUpdate' | translate }} :</label>
                    <p-checkbox [binary]="true" [(ngModel)]="uploadParams.forceUpload"></p-checkbox>

                </div>
                <div class="field col-12">
                    <label>{{ 'CompanyStampMaintenance.UploadFile.File' | translate }}</label>
                    <p-fileUpload #fileUpload accept="image/*" [customUpload]="true" (uploadHandler)="fileUploader($event)" chooseLabel="{{ 'CompanyStampMaintenance.UploadFile.Button.ChooseFile' | translate }}" uploadLabel="{{ 'CompanyStampMaintenance.UploadFile.Button.Upload' | translate }}" cancelLabel="{{ 'CompanyStampMaintenance.UploadFile.Button.Cancel' | translate }}">
                    </p-fileUpload>
                </div>
            </div>
        </ng-template>
        <p-footer>

        </p-footer>
    </p-dialog>

</div>
<help-dock
  [permissionCode]="viewPermissionCode"
  [lang]="currentLang">
</help-dock>
